export default __webpack_public_path__ + "static/media/EAST2460.34I-34261_-18480_0.faf4a564.jpg";